module.exports = __webpack_public_path__ + "01ea978f/img/delete-icon.eb7de062.svg";